import { formatProductDateTime } from "./product-date";

function pad(value: number) {
  return String(value).padStart(2, "0");
}

/** Serializes the wall-clock fields shown by the picker without applying the browser timezone. */
export function formatVenueWallClockInput(value: unknown): string | null {
  const date =
    value instanceof Date ? value : new Date(value as string | number);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}:00`;
}

function preferredWallClockValue(
  localValue: unknown,
  fallbackValue: unknown,
): unknown {
  return typeof localValue === "string" && localValue.trim()
    ? localValue
    : fallbackValue;
}

export function useVenueWallClockForDisplay<T extends Record<string, unknown>>(
  booking: T,
): T {
  return {
    ...booking,
    start: preferredWallClockValue(
      booking["localStartDatetime"],
      booking["start"],
    ),
    end: preferredWallClockValue(booking["localEndDatetime"], booking["end"]),
  };
}

/** Retained for existing calendar callers. */
export const useVenueWallClockForCalendar = useVenueWallClockForDisplay;

export function formatVenueWallClockDateTime(value: unknown): string {
  return formatProductDateTime(value);
}
